import React from 'react';
import {
  default as MuiFormHelperText,
  type FormHelperTextTypeMap as MuiFormHelperTextTypeMap,
  type FormHelperTextProps as MuiFormHelperTextProps,
} from '@mui/material/FormHelperText';
import type {
  OverridableComponent,
  OverrideProps,
} from '@mui/material/OverridableComponent';
import { DistributiveOmit } from '@mui/types';

/**
 * Props that we do not want to include with FormHelperText.
 *
 * Using `keyof Pick` provides type safety that ensures we are
 * only blocking props that are part of the interface.
 **/
type FormHelperTextBlockedProps = keyof Pick<
  MuiFormHelperTextProps,
  'variant' | 'filled'
>;

export interface FormHelperTextTypeMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {},
  RootComponent extends React.ElementType = MuiFormHelperTextTypeMap['defaultComponent']
> {
  props: AdditionalProps &
    DistributiveOmit<MuiFormHelperTextProps, FormHelperTextBlockedProps>;
  defaultComponent: RootComponent;
}

export type FormHelperTextProps<
  RootComponent extends React.ElementType = FormHelperTextTypeMap['defaultComponent'],
  // eslint-disable-next-line @typescript-eslint/ban-types
  AdditionalProps = {}
> = OverrideProps<
  FormHelperTextTypeMap<AdditionalProps, RootComponent>,
  RootComponent
> & {
  component?: React.ElementType;
};

export const FormHelperText: OverridableComponent<FormHelperTextTypeMap> =
  MuiFormHelperText;
